export default "__VITE_ASSET__eoSX0pqr__"